import { format, parseISO } from 'date-fns';
import { fr, enUS } from 'date-fns/locale';
import { Timestamp } from 'firebase/firestore';

const locales = {
  fr,
  en: enUS,
};

export const formatDate = (date: Date | Timestamp | undefined, formatStr = 'dd/MM/yyyy'): string => {
  try {
    if (!date) return '-';
    
    const dateObj = date instanceof Timestamp ? date.toDate() : date;
    const userLocale = localStorage.getItem('i18nextLng') || 'fr';
    const locale = locales[userLocale as keyof typeof locales] || locales.fr;
    return format(dateObj, formatStr, { locale });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

export const parseISODate = (dateStr: string): Date => {
  try {
    return parseISO(dateStr);
  } catch (error) {
    console.error('Error parsing ISO date:', error);
    return new Date();
  }
};
